export default "__VITE_ASSET__CfXzrQX5__"